<template>
  <smart-church-layout page="Income">
    <v-snackbar
      v-model="snackbar.status"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      >{{ snackbar.msg }}</v-snackbar
    >
    <v-overlay :opacity="0.4" :value="overlay">
      <v-progress-circular indeterminate size="64"> </v-progress-circular>
    </v-overlay>
    <!-- <skeletonLoader v-if="overlay" /> -->

    <v-container class="my-8">
      <v-row>
        <v-col cols="12" sm="12" class="d-flex d-md-none d-lg-none mt-5">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search Income"
            outlined
            rounded
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <h3 class="primary--text font-weight-bold d-lg-none mt-6">Income</h3>

      <div class="d-flex mb-5 mt-8">
        <h3 class="primary--text font-weight-bold d-none d-lg-block">Income</h3>
        <v-btn
          class="mx-5 font-weight-bold"
          :to="{ name: 'adminAddIncome' }"
          color="primary text--white"
          v-if="canManageIncomeReport || canManageExpenseReport || noRoles"
        >
          <v-icon>mdi-plus</v-icon> Record Income
        </v-btn>
        <v-spacer></v-spacer>
      </div>

      <v-row class="mt-5">
        <!-- <v-col>
          <v-spacer></v-spacer>
        </v-col> -->
        <v-col cols="12" lg="4">
          <v-autocomplete
            :items="branches"
            item-value="id"
            v-model="branch_id"
            @change="getAdditionalIncome((page = 1))"
            dense
            outlined
            rounded
            label="Select Branch"
            item-text="name"
          ></v-autocomplete>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="12" lg="4">
          <v-spacer></v-spacer>
        </v-col>
        <v-col lg="4">
          <v-text-field
            class="d-none d-md-flex"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search Income"
            outlined
            rounded
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="otherIncome"
        :search="search"
        disable-pagination
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog v-model="dialog2" max-width="600px">
              <v-card>
                <v-card-text>
                  <v-form class="pa-9" ref="form">
                    <h2
                      class="mb-4 primary--text d-flex justify-center font-weight-bold"
                    >
                      Update Additional Income
                    </h2>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="create_other_income.branch_id"
                          :items="branches"
                          dense
                          label="Branch"
                          item-value="id"
                          outlined
                          item-text="name"
                          :error-messages="create_other_income_errors.branch_id"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="create_other_income.income_title_id"
                          :items="incomeTitles"
                          dense
                          label="Income Title"
                         
                          item-value="id"
                          outlined
                          item-text="name"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          outlined
                          dense
                          id=" date"
                          type="date"
                          label="Date"
                          v-model="create_other_income.income_date"
                          :error-messages="
                            create_other_income_errors.income_date
                          "
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                          outlined
                          dense
                          id="amount"
                          label="₦ Amount"
                          type="number"
                          v-model="create_other_income.amount"
                          :error-messages="create_other_income_errors.amount"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          id="description"
                          label="description"
                          v-model="create_other_income.description"
                          :error-messages="
                            create_other_income_errors.description
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="primary white--text"
                      :loading="isSubmitted"
                      :disabled="isSubmitted"
                      block
                      @click="save"
                      >Update</v-btn
                    >
                    <p class="text-center my-3">
                      <v-btn depressed small @click="dialog2 = false"
                        >Close</v-btn
                      >
                    </p>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h6 text-center"
                  >Are you sure you want to delete this income?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="primary" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:[`item.income_date`]="{ item }">
          {{ getFormattedDate(item.income_date) }}
        </template>
        <template v-slot:[`item.description`]="{ item }">
          {{ item.description ? item.description : "No Description" }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          ₦{{ getFormattedAmount(item.amount) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="bg-transparent" depressed>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="
                  canManageIncomeReport || canManageExpenseReport || noRoles
                "
              >
                <v-list-item-title>
                  <a @click="editItem(item)"
                    ><v-icon small class="mr-2"> mdi-pencil </v-icon>Edit</a
                  >
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="
                  canManageIncomeReport || canManageExpenseReport || noRoles
                "
              >
                <v-list-item-title>
                  <a @click="deleteItem(item)"
                    ><v-icon small class="mr-2"> mdi-delete </v-icon>Delete</a
                  >
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <div class="text-end d-flex justify-end">
        <v-pagination
          v-model="page"
          :length="lastPage"
          @input="getAdditionalIncome"
        ></v-pagination>
        <span class="mt-3">Showing {{ from }} - {{ to }} of {{ total }} </span>
      </div>
    </v-container>
  </smart-church-layout>
</template>

<script>
import SmartChurchLayout from "../../components/Layouts/SmartChurchLayout.vue";

import {
  catchAxiosExceptions,
  getFormattedDate,
  getFormattedAmount,
} from "../../__helpers/handelExceptions";
// import skeletonLoader from "../../components/DataTableLoader.vue"
import { mapGetters } from "vuex";

export default {
  components: { SmartChurchLayout },

  data() {
    return {
      search: "",
      dialog: false,
      dialog2: false,
      dialogDelete: false,
      switch1: true,

      page: 1,
      lastPage: 1,
      from: 0,
      to: 0,
      total: 0,

      branch_id: 0,

      headers: [
        { text: "Date", value: "income_date" },
        { text: "Branch", value: "branch.name" },
        { text: "Name", value: "income_title.name" },
        { text: "Amount", value: "amount" },
        { text: "Description", value: "description" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      incomeTitles: [],
      otherIncome: [],
      branches: [],
      overlay: true,

      create_other_income: {
        income_date: "",
        branch_id: "",
        name: "",
        amount: "",
        description: "",
        income_title_id: "",
      },

      defaultItem: {
        income_date: "",
        branch_id: "",
        name: "",
        amount: "",
        description: "",
        income_title_id: "",
      },

      snackbar: {
        status: false,
        msg: "",
        color: "",
        timeout: 3000,
      },
      isSubmitted: false,

      otherIncomeTitles: [],

      serviceReports: [],
      editedIndex: -1,
      create_other_income_errors: {},

      isLoading: false,
      mountedError: null,

      user: this.$store.state.userDetail.user,

      userPermissionNames: [],
    };
  },

  watch: {
    dialog2(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    ...mapGetters([
      "canManageIncomeReport",
      "canViewIncomeReport",
      "canManageExpenseReport",
      "canViewExpenseReport",
      "noRoles",
      "canManageReports",
      "canViewReports",
      "isAdmin",
    ]),
  },

  methods: {
    async getAdditionalIncome(page = 1) {
      this.isLoading = true;
       this.overlay = true
      try {
        const otherIncome = await this.$http.get(
          `admin/other-incomes?branch_id=${this.branch_id}&page=${page}`
        );
        const user = this.$store.state.userDetail.user;

        const displayIncome = await this.$http.get("admin/income-title");
        this.incomeTitles = displayIncome.data.data;
        this.otherIncome = otherIncome.data.data;
        console.log(this.otherIncome);
        //
        this.page = otherIncome.data.meta.current_page;
        this.lastPage = otherIncome.data.meta.last_page;
        this.from = otherIncome.data.meta.from;
        this.to = otherIncome.data.meta.to;
        this.total = otherIncome.data.meta.total;
        //
        this.branches = user.branches;

        this.isLoading = false;
        this.overlay = false;
      } catch (error) {
        // this.mountedError = error.response.data.message;
        this.isLoading = false;
        this.overlay = false;

        catchAxiosExceptions(error);
      }
    },

    editItem(item) {
      this.editedIndex = this.otherIncome.indexOf(item);
      this.create_other_income = Object.assign({}, item);
      this.dialog2 = true;
    },

    save() {
      this.create_other_income.error = "";
      this.create_other_income.response = "";

      this.isSubmitted = true;

      this.$http
        .put(
          "admin/other-incomes/" + this.create_other_income.slug,
          this.create_other_income
        )
        .then((response) => {
          this.snackbar.status = true;
          this.snackbar.msg = response.data.message;
          this.snackbar.color = "green";
          this.isSubmitted = false;
          this.getAdditionalIncome();
          this.close();
        })
        .catch((error) => {
          this.snackbar.status = true;
          this.snackbar.msg = error.response.data.message;
          this.snackbar.color = "red";
          this.create_other_income_errors = error.response.data.errors;
          this.isSubmitted = false;

          catchAxiosExceptions(error);
        });
    },

    cancel() {
      this.dialog = false;
    },

    deleteItem(item) {
      this.editedIndex = this.otherIncome.indexOf(item);
      this.create_other_income = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.$http
        .delete("admin/other-incomes/" + this.create_other_income.slug)
        .then((response) => {
          this.snackbar.status = true;
          this.snackbar.msg = response.data.message;
          this.snackbar.color = "green";

          this.getAdditionalIncome();
          this.closeDelete();
        })
        .catch((error) => {
          this.snackbar.status = true;
          this.snackbar.msg = error.response.data.message;
          this.snackbar.color = "red";

          catchAxiosExceptions(error);
        });
    },

    close() {
      this.dialog2 = false;
      this.$nextTick(() => {
        this.create_other_income = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.create_other_income = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    getFormattedDate(date) {
      return getFormattedDate(date);
    },
    getFormattedAmount(amount) {
      return getFormattedAmount(amount);
    },
  },

  created() {
    this.$store.commit("allPermissions");
    this.branches = this.user.branches;
  },

  mounted() {
    // this.getAdditionalIncome();
    this.overlay = false;
  },
};
</script>

<style>
h3 {
  font-size: 24px !important;
}
/* .v-data-table__wrapper > table > thead > tr:nth-child(even) {
  background-color: #fde4e4 !important;
}
.v-data-table__wrapper > table > thead > tr:nth-child(odd) {
  background-color: #fff !important;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  color: rgb(204, 89, 89) !important;
  font-size: 1em !important;
}
tr:nth-child(odd) {
  background-color: #fff !important;
}
tr:nth-child(even) {
  background-color: #fde4e4 !important;
} */
</style>
